const usersListStyles = ({ palette }) => {
    return {
        usersList: () => ({
            backgroundColor: palette.background.background,
            padding: '0 16px',
            borderRadius: '8px',
            marginTop: 0,
            overflow: 'hidden',
            '& .MuiDataGrid-footerContainer': {
                height: '38px',
                minHeight: '38px',
            },
            '& .MuiDataGrid-overlayWrapper': {
                height: '100%',
                minHeight: '100%',
            },
        }),
    };
};
export default usersListStyles;
